var _rect, _path, _path2, _path3, _circle, _path4, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpLeadGen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7813 32.8968C43.9208 30.1083 46.1631 28.9465 47.2669 28.7141C50.8918 33.0362 54.5864 30.515 55.9806 28.7141L57.7234 29.4112C56.4686 31.2237 57.2006 33.3034 57.7234 34.1167C54.6562 33.8378 53.5408 36.0918 53.3665 37.2537V41.262H47.2669V36.208C47.2669 33.6984 44.9432 32.9549 43.7813 32.8968Z",
    fill: "#FBE209"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4741 45.9674C21.1952 42.6213 25.192 41.2038 27.2252 40.9134V42.6561C22.7637 44.608 25.3662 47.1873 27.2252 48.233C32.6626 51.7185 45.0013 52.3575 50.4039 52.067C68.18 52.067 73.2921 48.9301 75.6738 46.8387C76.7892 44.608 74.512 43.1209 73.234 42.6561V40.9134L76.1967 41.6105C80.1004 43.2835 79.6822 46.7226 78.9851 48.233L54.2379 72.9801V78.7312C54.0985 79.7072 53.018 79.9511 52.4952 79.9511H49.0096C47.6154 80.23 46.9183 79.254 46.7441 78.7312V72.9801L23.9139 50.3243C21.8226 47.9541 21.416 46.4321 21.4741 45.9674Z",
    fill: "#4C91E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4579 38.4734C55.4579 35.685 58.0139 34.9879 59.292 34.9879C60.1285 36.5215 61.9642 37.2535 62.7775 37.4277C65.9841 37.5672 67.7153 35.8592 68.18 34.9879C70.9684 34.9879 71.6655 37.3115 71.6655 38.4734C71.6074 40.7971 71.5261 45.5141 71.6655 45.793C65.8099 49.2785 58.4206 47.2453 55.4579 45.793V38.4734Z",
    fill: "#2EC272"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.4745,
    cy: 31.1541,
    r: 4.53117,
    fill: "#332D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3165 37.4278C29.3165 34.6394 31.8726 33.9422 33.1506 33.9422C33.9871 35.4759 35.8228 36.2078 36.6361 36.3821C39.8428 36.5215 41.5739 34.8136 42.0387 33.9422C44.8271 33.9422 45.5242 36.2659 45.5242 37.4278C45.4661 39.7514 45.3848 44.4685 45.5242 44.7473C39.6685 48.2329 32.2792 46.1996 29.3165 44.7473V37.4278Z",
    fill: "#E63535"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.3331,
    cy: 30.1084,
    r: 4.53117,
    fill: "#332D2D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.4495,
    cy: 24.7054,
    r: 4.70545,
    fill: "#332D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpLeadGen);
export default __webpack_public_path__ + "static/media/cp_lead-gen.fa061164cf402bb93bfd5bd0bb973212.svg";
export { ForwardRef as ReactComponent };